export const locationApi = {
  GET_LOCATIONS: "get-locations",
  DELETE_LOCATION: "delete-location",
  CREATE_LOCATION: "create-location",
  UPDATE_LOCATION: "update-location"
};
